import React, { useEffect } from "react";
import ServiceBanner from "../components/Services/ServiceBanner";
import HomeServices from "../components/home/HomeServices";
import { useLenis } from "lenis/react";

const ServicePage = () => {
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) {
      lenis.scrollTo(0, {
        duration: 1.2,
      });
    }
  }, [lenis]);
  return (
    <>
      <ServiceBanner />
      <HomeServices />
    </>
  );
};

export default ServicePage;
